export default __webpack_public_path__ + "static/media/logomark-DAW.1396426b.svg";